import React from 'react';
import './styles.scss';

function CameraAppointmentConfirmedIcon() {
  return (
    <svg
      className="camera-icon-doctors-list"
      width="14px"
      height="10px"
      viewBox="0 0 14 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>8008F81F-2051-42D7-AAE7-CCC7984E939F@1,5x</title>
      <g
        id="08---Consultas-Online"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="MY-D-08-01-06"
          transform="translate(-991.000000, -687.000000)"
          fill="#000000">
          <g id="Group-13" transform="translate(208.055682, 438.000000)">
            <g id="Group-5" transform="translate(0.000000, 58.378092)">
              <g id="Group-3" transform="translate(173.944318, 110.000000)">
                <g
                  id="cards/lista_médicos-copy-4"
                  transform="translate(0.000000, 78.000000)">
                  <g id="Group" transform="translate(609.000000, 1.000000)">
                    <g
                      id="ELEMENTS/ICONS/Camera/Standard"
                      transform="translate(0.656250, 2.406250)">
                      <path
                        d="M11.7560953,0.624378667 L9.21563672,2.35527013 L9.21563672,1.79677314 C9.21563672,0.804442737 8.53692838,0 7.69969922,0 L1.5159375,0 C0.678708337,0 0,0.804442737 0,1.79677314 L0,7.39072686 C0,8.38305726 0.678708337,9.1875 1.5159375,9.1875 L7.69969922,9.1875 C8.53692838,9.1875 9.21563672,8.38305726 9.21563672,7.39072686 L9.21563672,6.83222987 L11.7560953,8.56312133 C12.2374055,8.89103243 12.6328125,8.62151646 12.6328125,7.96419695 L12.6328125,1.22629767 C12.6328125,0.56598354 12.2386688,0.296467568 11.7560953,0.624378667 Z"
                        id="lists/icon_camera-small"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export default CameraAppointmentConfirmedIcon;
